import * as React from 'react';
import React__default from 'react';

function _extends$C() {
  _extends$C = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$C.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function (a) {
  return z(a) === k;
};

var isContextProvider = function (a) {
  return z(a) === h;
};

var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function (a) {
  return z(a) === n;
};

var isFragment = function (a) {
  return z(a) === e;
};

var isLazy = function (a) {
  return z(a) === t;
};

var isMemo = function (a) {
  return z(a) === r;
};

var isPortal = function (a) {
  return z(a) === d;
};

var isProfiler = function (a) {
  return z(a) === g;
};

var isStrictMode = function (a) {
  return z(a) === f;
};

var isSuspense = function (a) {
  return z(a) === p;
};

var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function () {
    // nor polyfill, then a plain number is used for performance.

    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }

    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;

        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;

            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;

              default:
                var $$typeofType = type && type.$$typeof;

                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;

                  default:
                    return $$typeof;
                }

            }

          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }

      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode


    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }

    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }

    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }

    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }

    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }

    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }

    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }

    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }

    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }

    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }

    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }

    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }

    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }

    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function () {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;

  var loggedTypeFailures = {};

  var has = has$1;

  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {
      /**/
    }
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */











var printWarning = function () {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);

        if (checkerResult == null) {
          return null;
        }

        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }

      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var propTypes = createCommonjsModule(function (module) {
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod


  var throwOnDirectAccess = true;
  module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2();
}
});

var PropTypes = propTypes;

function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var _ref$B = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.001L46 3zM24.5 5.5c10.489.011 18.988 8.511 19 19 0 10.493-8.506 19-19 19-10.493 0-19-8.507-19-19 0-10.494 8.507-19 19-19zm0 2c-9.389 0-17 7.61-17 17 0 9.388 7.611 17 17 17 9.385-.01 16.99-7.616 17-17 0-9.39-7.611-17-17-17zm8.6 10a2.837 2.837 0 012.717 2.528c.12.79-.078 1.594-.553 2.236a2.564 2.564 0 01-1.703 1.016l-5.35.749v2.499l3.518 8.448A2.908 2.908 0 0129.039 39a2.912 2.912 0 01-2.697-1.794L24.5 32.784l-1.843 4.422A2.912 2.912 0 0119.958 39a2.913 2.913 0 01-2.69-4.019l3.52-8.453v-2.5l-5.35-.748a2.603 2.603 0 01-1.853-1.236 3.046 3.046 0 01-.404-2.013A2.842 2.842 0 0115.9 17.5c.11 0 .22.008.33.022l6.43.9h3.679l6.428-.9c.11-.015.221-.022.332-.022zm0 2l-6.553.912a.945.945 0 01-.139.01h-3.817a.946.946 0 01-.139-.01l-6.482-.908a.87.87 0 00-.808.802c-.038.239.008.483.129.692.09.158.244.268.423.301l6.214.87a1 1 0 01.861.99v3.57c0 .131-.026.262-.077.384l-3.597 8.635a.912.912 0 00.498 1.182.934.934 0 001.198-.493l2.765-6.639a1 1 0 011.847 0l2.765 6.638c.2.462.73.681 1.197.494a.892.892 0 00.498-.495.875.875 0 000-.687l-3.595-8.635a1.002 1.002 0 01-.077-.385v-3.57a1 1 0 01.861-.99l6.213-.869a.585.585 0 00.381-.239c.153-.218.215-.487.171-.75a.86.86 0 00-.738-.81zM24.5 9a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z"
});

function SvgAccessibleWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$B);
}

function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var _ref$A = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm0 2H3v43h43.001L46 3zm-22.573 9.723a2.708 2.708 0 012.79-.163 2.827 2.827 0 011.533 2.518v18.888a2.774 2.774 0 01-1.503 2.475 2.75 2.75 0 01-2.87-.206l-8.54-5.835H7.5V18.59h7.337zm1.868 1.622a.703.703 0 00-.72.026l-9.119 6.23H9.508v7.79h5.948l9.07 6.195a.75.75 0 00.8.07.772.772 0 00.417-.69V15.079a.825.825 0 00-.448-.733zM37.467 15a13.204 13.204 0 010 19L36 32.527a11.15 11.15 0 000-16.054zm-4.516 3.5a8.335 8.335 0 010 12l-1.45-1.456a6.306 6.306 0 000-9.088z"
});

function SvgAcousticSignals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$A);
}

function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var _ref$z = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm0 2H3v43h18.415c-.252-1.684-.729-4.844-1.22-8.051l-.175-1.132c-.464-3.01-.92-5.912-1.197-7.514-8.923 1.733-12.805-3.345-14.081-5.68a2.01 2.01 0 01.77-2.695l5.229-2.983 3.842-4.644 3.919-1.8-.364-3.387.015-.119a2 2 0 011.12-1.547 1.975 1.975 0 011.891.091c1.645 1.003 3.625 2.36 4.34 3.977A26.88 26.88 0 0126.6 13.87l9.258 10.963L46 7.832V3zm-9.944 24.613l-14.25 7.667c.641 4.129 1.337 8.754 1.632 10.72h22.563V30.442l-9.945-2.829zM35.5 33.5v4h4v2h-4v4h-2v-4h-4v-2h4v-4h2zM20.165 8.276l.479 4.446-4.814 2.21-3.783 4.573L6.5 22.67c1.097 2.01 4.563 6.483 12.882 4.46l1.007-.244.209 1.015c.154.747.489 2.795.88 5.286l12.935-6.96-9.636-11.41-.057-.224a27.618 27.618 0 00-1.045-3.264c-.543-1.229-2.731-2.577-3.51-3.052zM46 11.734l-8.478 14.213L46 28.36V11.734z"
});

function SvgAssistanceDog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$z);
}

function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var _ref$y = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zm-5 5.587v32h2.5v2h-38v-2H8v-32h33zm-17.5 2H10v30h13.5v-30zm15.5 0H25.5v30H39v-30zm-21.373 8L19 19.968l-3.206 3.117L19 26.206l-1.373 1.381L13 23.083l4.627-4.496zm13.746 0L36 23.091l-4.627 4.496L30 26.206l3.206-3.117L30 19.968l1.373-1.381z"
});

function SvgAutomaticEntranceDoor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$y);
}

function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var _ref$x = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM17 22.75v2.055a8.5 8.5 0 1011 8.089v-.268h2v.268A10.457 10.457 0 1117 22.75zm4.467-6.659a2.6 2.6 0 012.958 1.243l3.888 6.754h5.05v2h-6.206l-4.464-7.759a.602.602 0 00-.712-.306.634.634 0 00-.482.644l.002 7.846a1.602 1.602 0 001.581 1.618h10.349l6.42 10.852L38.13 40l-5.84-9.87h-9.209a3.603 3.603 0 01-3.58-3.617l-.002-7.846a2.63 2.63 0 011.967-2.576zM22 6a4 4 0 110 8 4 4 0 010-8zm0 2a2 2 0 100 4 2 2 0 000-4z"
});

function SvgBarrierFreeAccessibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$x);
}

function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var _ref$w = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm0 2H3v43h43.001L46 3zM18.017 32.842a3 3 0 110 6 3 3 0 010-6zm12.967 0a3 3 0 110 6 3 3 0 010-6zM18.052 21.5a3 3 0 110 6 3 3 0 010-6zm12.896 0a3 3 0 110 6 3 3 0 010-6zM18.017 10.158a3 3 0 110 6 3 3 0 010-6zm12.967 0a3 3 0 110 6 3 3 0 010-6z"
});

function SvgBraille(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$w);
}

function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var _ref$v = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM16.5 15.5v1.993H8v17.015h4V29.5a2.003 2.003 0 012-2h2.5v2H14v12h10.5v-4h2v4h5v-16h-5v7h-2v-3h-3v-2h3v-10h-3v-2h3a2.003 2.003 0 012 2v6h5a2.003 2.003 0 012 2v16a2.003 2.003 0 01-2 2H14a2.003 2.003 0 01-2-2v-5H8a1.999 1.999 0 01-2-1.992V17.493A1.999 1.999 0 018 15.5h8.5zM36 17.1a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5.6 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM18.999 7.5c1.81.021 3.262 1.5 3.251 3.31.002 1.377-.735 2.169-2.55 3.986l-.704.704-.703-.705c-1.808-1.812-2.541-2.604-2.543-3.988a3.33 3.33 0 011.618-2.861A3.21 3.21 0 0119 7.5zM36 11.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5.6 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM18.997 9.524a1.22 1.22 0 00-.62.169c-.39.234-.628.657-.627 1.112 0 .376.116.66 1.248 1.837 1.143-1.184 1.252-1.453 1.252-1.83a1.274 1.274 0 00-1.253-1.288zM36 6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm5.6 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
});

function SvgBuildingPlanBraille(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$v);
}

function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var _ref$u = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm0 2H3v43h43.001L46 3zM17.192 29.985a6.091 6.091 0 014.704-.025c.707.292 5.287 2.24 5.287 2.24a2.869 2.869 0 011.747 2.445l1.573-.696.467-.207 4.2-1.858a2.883 2.883 0 013.806 1.388 2.859 2.859 0 01-1.388 3.811c-.532.244-2.96 1.36-5.52 2.527l-.67.305c-2.793 1.272-5.561 2.522-6.04 2.697a6.91 6.91 0 01-2.384.388 12.9 12.9 0 01-2.488-.276c-.804-.16-4.597-1.054-5.321-1.225H9.75V31.002h5.295a58.851 58.851 0 012.147-1.017zm3.94 1.822a4.119 4.119 0 00-3.131.006c-1.013.448-2.27 1.081-2.27 1.081l-.213.108H11.75v6.497l3.761.028c.045.01 4.528 1.07 5.362 1.235a7.667 7.667 0 003.796-.026c.44-.162 3.609-1.594 7.003-3.143l.583-.267c1.56-.712 3.137-1.435 4.493-2.058a.866.866 0 00.45-.49.854.854 0 00-.03-.655.886.886 0 00-1.172-.419c-.343.153-8.03 3.557-8.663 3.826a3.612 3.612 0 01-2.4-.058l-4.715-2.007.783-1.84 4.668 1.987c.14.04.281.07.425.088a.877.877 0 00.771-.528.86.86 0 00-.463-1.13c-.002-.003-4.567-1.943-5.27-2.235zM29.835 6.5a7.237 7.237 0 015.202 2.192c1.829 1.864 2.197 3.768 2.212 9.48v.733c-.001.503-.005 1.033-.01 1.594l-.007.982-.979.01c-.654.006-1.274.009-1.859.009a41.166 41.166 0 01-5.475-.258 8.936 8.936 0 01-1.54 2.075C25.127 25.572 22.777 26 15.574 26h-.484c-.656-.002-1.351-.007-2.088-.014l-.981-.009-.01-.982c-.005-.626-.008-1.222-.01-1.789v-1.229c.024-6.833.486-9.13 2.706-11.352A8.89 8.89 0 0121.042 8c1.223 0 2.433.25 3.555.735.013-.013.023-.028.035-.041A7.237 7.237 0 0129.835 6.5zM21.043 10a6.906 6.906 0 00-4.92 2.038c-1.68 1.68-2.108 3.41-2.121 10.33v.791l.003.835c8.321.05 10.174-.303 11.959-2.09a6.991 6.991 0 00.002-9.864A6.908 6.908 0 0021.043 10zm8.793-1.5a5.236 5.236 0 00-3.425 1.296 8.86 8.86 0 013.27 9.53c1.853.156 3.714.213 5.574.172l.001-.385v-.735c-.01-5.574-.34-6.96-1.64-8.283a5.26 5.26 0 00-3.78-1.595z"
});

function SvgCommunicationAids(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$u);
}

function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var _ref$t = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM30.01 6c3.23 0 5.96 2.491 5.96 5.44H33.95a3.762 3.762 0 00-3.942-3.427 3.854 3.854 0 00-3.972 3.707v25.81a3.854 3.854 0 003.972 3.706 3.853 3.853 0 003.973-3.712H36a5.87 5.87 0 01-5.99 5.726 6.067 6.067 0 01-4.981-2.548 6.04 6.04 0 01-4.963 2.548 5.928 5.928 0 01-5.942-5.215 6.487 6.487 0 01-3.208-2.053 7.832 7.832 0 01-1.913-5.345A7.587 7.587 0 016.6 23.692a7.811 7.811 0 013.31-5.398 5.474 5.474 0 01-.446-2.164 5.788 5.788 0 014.78-5.59A5.913 5.913 0 0120.065 6a6.04 6.04 0 014.964 2.548A6.067 6.067 0 0130.009 6zm-9.747 2.013h-.197a3.85 3.85 0 00-3.925 3.49l-.057.89-.892.052a3.817 3.817 0 00-3.709 3.686c.004.451.095.898.27 1.315 1.761-.525 4.636-.433 7.118 2.537l-1.55 1.29c-1.885-2.257-3.777-2.21-4.797-1.95l-.87.334a5.504 5.504 0 00-3.058 4.34 5.625 5.625 0 002.067 5.406l.42.333-.042.534a5.888 5.888 0 001.396 4.39 4.728 4.728 0 001.811 1.303 5.255 5.255 0 012.536-3.584l.903 1.801a3.615 3.615 0 00-1.573 3.33 3.883 3.883 0 003.952 3.726l.197.001a3.843 3.843 0 003.755-3.707V19.42a3.59 3.59 0 00-3.589-3.58v-2.014a5.589 5.589 0 013.59 1.301v-3.4h-.001a3.843 3.843 0 00-3.952-3.713zM36 31.5a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-15.744-7.29l1.427 1.423a7.026 7.026 0 01-2.226 1.495c.952.9 1.55 2.111 1.683 3.415l-2.008.202a3.46 3.46 0 00-2.433-2.961l.028-.09-.045.001a7.057 7.057 0 01-5-2.062l1.426-1.424a5.07 5.07 0 007.148 0zM36 14a5.5 5.5 0 015.5 5.488 5.763 5.763 0 01-4.5 5.705v4.38h-2v-6.197l.94-.057a3.738 3.738 0 003.56-3.831 3.5 3.5 0 00-7 0h-2A5.5 5.5 0 0136 14z"
});

function SvgDementia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$t);
}

function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var _ref$s = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.001L46 3zM18.349 17.807a9.1 9.1 0 016.151 2.381 9.1 9.1 0 016.151-2.381H41v23.037H30.383a6.623 6.623 0 00-5.045 2.496.953.953 0 01-.836.467 1.073 1.073 0 01-.838-.466 6.627 6.627 0 00-5.315-2.497H8V17.807zm0 1.999H10v19.04h8.349a9.469 9.469 0 015.151 1.577V22.097a6.757 6.757 0 00-5.151-2.291zm20.651 0h-8.349a6.757 6.757 0 00-5.151 2.29v18.327a9.469 9.469 0 015.151-1.578H39v-19.04zm-3 13.001v2h-7.5v-2H36zm0-4.5v2h-7.5v-2H36zm0-4.5v2h-7.5v-2H36zm-11.5-18.5a5.5 5.5 0 010 11 5.507 5.507 0 01-5.5-5.5 5.5 5.5 0 015.5-5.5zm0 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"
});

function SvgEasyLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$s);
}

function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var _ref$r = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm0 2H3v43h43.001L46 3zm-9 3a4.004 4.004 0 014 4v4.16h-2V10a2.003 2.003 0 00-2-2H10a2.003 2.003 0 00-2 2v29a2.003 2.003 0 002 2h27a2.003 2.003 0 002-2v-4.16h2V39a4.004 4.004 0 01-4 4H10a4.004 4.004 0 01-4-4V10a4.004 4.004 0 014-4zM14.058 20.39a8.096 8.096 0 017.38 0l.39.226.09.44a4591.82 4591.82 0 012.59 12.762l.242 1.2h-3.99V38H18.75v-4.987h3.547l-.072-.356-.08-.4c-.413-2.038-1.134-5.598-2.1-10.33a6.148 6.148 0 00-4.594-.002c-1.097 5.385-1.878 9.253-2.25 11.088h3.548V38h-2.008v-2.983H10.75l.241-1.2s.963-4.784 2.59-12.76l.089-.44zM41.818 27l1.432 1.377-3.253 3.123-3.247-3.123L38.183 27 40 28.746 41.817 27zM27.25 19.5a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.5 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm8.253-2l3.247 3.123L41.817 22l-1.816-1.746L38.183 22l-1.433-1.377 3.253-3.123zM27.25 15a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.5 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm-14-4.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm9.5-2a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm4.5 0a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5z"
});

function SvgElevatorBraille(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$r);
}

function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var _ref$q = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zm-9 3a4.004 4.004 0 014 4v4.16h-2V10a2.003 2.003 0 00-2-2H10a2.003 2.003 0 00-2 2v29a2.003 2.003 0 002 2h27a2.003 2.003 0 002-2v-4.159h2v4.16a4.004 4.004 0 01-4 4H10a4.004 4.004 0 01-4-4V10a4.004 4.004 0 014-4zm-19.016 6.5l1.837 13.358H29V36.5h-2.001v-3.829h-7.051v3.83h-2.001v-9.577L16 12.77l1.984-.27zM41.817 27l1.433 1.377-3.253 3.123-3.247-3.123L38.183 27l1.816 1.746L41.817 27zm-14.818.847h-7.051v2.836h7.05v-2.836zM40.003 17.5l3.247 3.123L41.817 22l-1.816-1.746L38.183 22l-1.433-1.377 3.253-3.123z"
});

function SvgElevatorSeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$q);
}

function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var _ref$p = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2h43zm0 2H3v43h43.002L46 3zm-9 3a4.004 4.004 0 014 4v4.16h-2V10a2.003 2.003 0 00-2-2H10a2.003 2.003 0 00-2 2v29a2.003 2.003 0 002 2h27a2.003 2.003 0 002-2v-4.159h2v4.16a4.004 4.004 0 01-4 4H10a4.004 4.004 0 01-4-4V10a4.004 4.004 0 014-4h27zM21.44 20.39l.389.226.09.44c1.629 7.978 2.591 12.763 2.591 12.763l.241 1.199h-3.99V38H18.75v-4.986h3.547c-.37-1.835-1.153-5.701-2.252-11.086a6.148 6.148 0 00-4.594-.002 6400.186 6400.186 0 00-2.25 11.088h3.548V38H14.74v-2.982h-3.99l.24-1.2s.963-4.784 2.59-12.761l.089-.44.388-.227a8.097 8.097 0 017.38 0zM41.817 27l1.433 1.377-3.253 3.123-3.247-3.123L38.183 27 40 28.746 41.817 27zm-1.814-9.5l3.247 3.123L41.817 22l-1.816-1.746L38.183 22l-1.433-1.377 3.253-3.123zM29.75 12c3.337 0 5.91 3.245 6.018 3.383l.482.617-.482.618C35.66 16.755 33.088 20 29.75 20c-3.337 0-5.91-3.245-6.018-3.382L23.25 16l.482-.617C23.84 15.245 26.413 12 29.75 12zm1.841 2.485a1.927 1.927 0 11-3.683.005 8.39 8.39 0 00-2.041 1.512A6.093 6.093 0 0029.75 18a6.131 6.131 0 003.883-2.002 8.259 8.259 0 00-2.042-1.513zM17.751 10.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
});

function SvgElevatorVisualDisplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$p);
}

function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var _ref$o = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm0 2H3v43h43.001L46 3zm-9 3a4.004 4.004 0 014 4v4.16h-2V10a2.003 2.003 0 00-2-2H10a2.003 2.003 0 00-2 2v29a2.003 2.003 0 002 2h27a2.003 2.003 0 002-2v-4.16h2V39a4.004 4.004 0 01-4 4H10a4.004 4.004 0 01-4-4V10a4.004 4.004 0 014-4zM14.058 20.39a8.097 8.097 0 017.38 0l.39.226.09.44a4591.82 4591.82 0 012.59 12.762l.242 1.2h-3.99V38H18.75v-4.987h3.547l-.072-.356-.08-.4c-.413-2.038-1.134-5.598-2.1-10.33a6.148 6.148 0 00-4.594-.002c-1.097 5.385-1.878 9.253-2.25 11.088h3.548V38h-2.008v-2.983H10.75l.241-1.2s.963-4.784 2.59-12.76l.089-.44zM41.818 27l1.432 1.377-3.253 3.123-3.247-3.123L38.183 27 40 28.746 41.817 27zm-1.815-9.5l3.247 3.123L41.817 22l-1.816-1.746L38.183 22l-1.433-1.377 3.253-3.123zm-10.956-6.736a1.58 1.58 0 011.591-.094c.527.262.86.8.862 1.388v7.397c0 .583-.33 1.115-.851 1.374-.223.112-.47.17-.719.17-.325.002-.642-.098-.91-.284l-2.643-1.77H23.5V12.55h2.877zM33 12.25a3.5 3.5 0 010 7v-2a1.5 1.5 0 000-3zm-3.475.54l-2.539 1.699h-1.51v2.518h1.51l2.54 1.7V12.79zM17.75 10.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
});

function SvgElevatorVoiceAnnouncement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$o);
}

function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var _ref$n = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zm-9 3a4.004 4.004 0 014 4v4.16h-2V10a2.003 2.003 0 00-2-2H10a2.003 2.003 0 00-2 2v29a2.003 2.003 0 002 2h27a2.003 2.003 0 002-2v-4.159h2v4.16a4.004 4.004 0 01-4 4H10a4.004 4.004 0 01-4-4V10a4.004 4.004 0 014-4zM19.066 22.75v2.055a4.232 4.232 0 104.91 4.385l.006-.21H26a6.268 6.268 0 11-6.934-6.23zm5.13-3.939l.085.135 1.658 2.862h2.632v2.012H24.78l-2.018-3.482v4.92h6.382l3.606 6.083-1.731 1.025-3.02-5.097h-5.333a1.918 1.918 0 01-1.909-1.763l-.006-.15-.001-5.462a1.893 1.893 0 013.445-1.083zm17.621 8.19l1.433 1.376-3.253 3.123-3.247-3.123L38.183 27l1.816 1.746L41.817 27zm-1.814-9.5l3.247 3.122L41.817 22l-1.816-1.746L38.183 22l-1.433-1.377 3.253-3.123zm-17.253-5a2 2 0 110 4 2 2 0 010-4z"
});

function SvgElevatorWheelchairAccessible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$n);
}

function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var _ref$m = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2h43zm0 2H3v43h43.002L46 3zM10.567 31.25v2.055a4.232 4.232 0 104.915 4.175H17.5a6.268 6.268 0 11-6.933-6.23zm5.214-3.805l1.658 2.863h2.632v2.012H16.28l-2.018-3.483.001 4.92h6.38l3.607 6.083-1.73 1.026-3.022-5.097h-5.332a1.918 1.918 0 01-1.915-1.913v-5.463a1.893 1.893 0 013.53-.948zm6.767-21.931a1.863 1.863 0 012.568-.002l5.321 5.324a1.82 1.82 0 010 2.57l-2.47 2.472a7.874 7.874 0 005.142 5.145l2.471-2.471a1.861 1.861 0 012.57 0l5.318 5.32a1.817 1.817 0 01-.002 2.571l-3.158 3.16A5.337 5.337 0 0136.476 31c-3.316 0-6.965-1.88-8.43-2.872a26.754 26.754 0 01-7.183-7.184c-1.81-2.673-4.552-9.189-1.475-12.267zm1.285 1.545l-3.03 3.033c-2.027 2.028.156 7.425 1.717 9.73a24.746 24.746 0 006.647 6.649 15.451 15.451 0 007.309 2.528 3.378 3.378 0 002.416-.81l3.031-3.033-5.058-5.058-3.187 3.187-.567-.163a10.016 10.016 0 01-7.244-7.246l-.163-.567 3.188-3.188-5.059-5.062zM14.25 21a2 2 0 110 4 2 2 0 010-4zM40.5 5.5v3h3v2h-3v3h-2v-3h-3v-2h3v-3h2z"
});

function SvgEmergencyCallSystemsWheelchairAccessible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$m);
}

function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var _ref$l = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM11.435 41.25v2H5.5v-2h5.935zm8.065 0v2h-5.934v-2H19.5zm3.294-.017a1 1 0 110 2 1 1 0 010-2zm3.414 0a1 1 0 110 2 1 1 0 010-2zm8.977-.004v2H29.25v-2h5.935zm8.065 0v2h-5.935v-2h5.935zM11.435 37.25v2H5.5v-2h5.935zm8.065 0v2h-5.934v-2H19.5zm15.685 0v2H29.25v-2h5.935zm8.065 0v2h-5.935v-2h5.935zm-20.456 0a1 1 0 110 2 1 1 0 010-2zm3.414 0a1 1 0 110 2 1 1 0 010-2zm-7.175-22.476a7.14 7.14 0 018.143 0l.419.3v.007l4.502 7.738-1.745 1.005-2.757-4.738v6.302h-1.37l1.863 3.405.062 5.935-2.017.022-.056-5.435-2.15-3.927h-1.79l-1.142 4.527-3.998 4.407-1.497-1.345 3.661-4.036.896-3.553h-1.442V15.075zm14.16 9.744l5.307 9.12-1.745 1.005-5.308-9.12 1.745-1.005zm-7.616-8.386a5.03 5.03 0 00-4.945 0v7.25h4.945zM21.66 5.017a3.5 3.5 0 112.68 6.466 3.5 3.5 0 01-2.68-6.466zM23 6.72a1.517 1.517 0 00-1.5 1.53A1.53 1.53 0 1023 6.72z"
});

function SvgGuideSystemForTheBlind(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$l);
}

function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var _ref$k = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zm-8.635 4.25L38.8 8.685l-4.11 4.11a11.027 11.027 0 01-1.17 14.793l-4.18 4.194-.001 5.222A4.97 4.97 0 0124.289 42a5.065 5.065 0 01-5.053-5.065h2A3.062 3.062 0 0024.288 40a2.992 2.992 0 003.05-2.996l.002-6.048 4.786-4.804A9 9 0 1017 19.534h-2a10.975 10.975 0 0118.307-8.225l4.058-4.059zm-17.26 17l1.395 1.394L11.394 35.75 10 34.356 20.106 24.25zM26 13.5a6 6 0 016 5.97 5.908 5.908 0 01-1.807 4.27l-4.486 4.46-1.41-1.417 4.494-4.47A3.932 3.932 0 0030 19.47a4 4 0 00-8 0h-2a6 6 0 016-5.97z"
});

function SvgHearingImpairment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$k);
}

function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var _ref$j = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2h43zm0 2H3v43h43.002L46 3zM17.192 29.985a6.091 6.091 0 014.704-.025c.707.292 5.287 2.24 5.287 2.24a2.869 2.869 0 011.747 2.445c2.543-1.124 6.186-2.738 6.24-2.761a2.883 2.883 0 013.806 1.388 2.859 2.859 0 01-1.388 3.811c-.532.244-2.96 1.36-5.52 2.527l-.67.305c-2.793 1.272-5.561 2.522-6.04 2.697a6.91 6.91 0 01-2.384.388 12.9 12.9 0 01-2.488-.276c-.804-.16-4.596-1.054-5.321-1.225H9.75V31.002h5.295a58.86 58.86 0 012.147-1.017zm3.94 1.822a4.119 4.119 0 00-3.131.006c-1.013.448-2.27 1.081-2.27 1.081l-.213.108H11.75v6.497l3.762.028c.022.005 1.154.273 2.384.56l.696.161c1.001.232 1.942.447 2.282.514a7.667 7.667 0 003.795-.026c.428-.157 3.43-1.514 6.713-3.01l.581-.266c1.654-.755 3.345-1.53 4.785-2.192a.866.866 0 00.45-.49.854.854 0 00-.03-.655.886.886 0 00-1.172-.419c-.343.153-8.03 3.557-8.663 3.826a3.612 3.612 0 01-2.4-.058l-4.715-2.008.784-1.839 4.667 1.987c.14.04.281.07.425.088a.877.877 0 00.772-.528.86.86 0 00-.463-1.13c-.003-.003-4.568-1.943-5.272-2.235zM25.21 6.302A3.887 3.887 0 0132 8.877h-2.023a1.874 1.874 0 00-3.748-.01v14.765a1.871 1.871 0 001.874 1.855 1.872 1.872 0 001.874-1.865H32a3.889 3.889 0 01-6.758 2.614 4.016 4.016 0 01-2.808 1.264 3.927 3.927 0 01-3.878-3.077 4.848 4.848 0 01-3.8-2.73 5.015 5.015 0 01-.03-4.172 5.92 5.92 0 01-.932-5.473 5.218 5.218 0 013.956-3.553 3.917 3.917 0 011.365-2.35A4.77 4.77 0 0122.106 5a4.583 4.583 0 013.104 1.302zm-3.104.71a2.775 2.775 0 00-1.695.678 2.076 2.076 0 00-.716 1.683v.932l-.934.072a3.242 3.242 0 00-3.042 2.29 3.778 3.778 0 00.933 3.948l.755.637-.624.765a2.847 2.847 0 00-.194 2.827 2.964 2.964 0 002.901 1.642l.993.019v.987a1.928 1.928 0 001.95 1.995 1.72 1.72 0 001.773-1.796v-.06l-.001-.009V8.74c0-1.274-1.373-1.727-2.099-1.727zM33.75 20a1.25 1.25 0 110 2.5 1.25 1.25 0 010-2.5zm0-9.5A3.262 3.262 0 0137 13.766a3.4 3.4 0 01-2.254 3.254v1.48h-1.991v-3.233l.935-.057a1.399 1.399 0 001.32-1.444 1.259 1.259 0 10-2.519 0h-1.99a3.262 3.262 0 013.25-3.266z"
});

function SvgHelpDementia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$j);
}

function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var _ref$i = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM17.191 29.982a6.092 6.092 0 014.705-.025c.708.292 5.288 2.241 5.288 2.241a2.872 2.872 0 011.747 2.446l1.573-.696.467-.206 4.2-1.86a2.883 2.883 0 013.806 1.389 2.86 2.86 0 01-1.39 3.812c-1.153.53-11.272 5.18-12.228 5.531-.766.269-1.573.4-2.384.388a12.902 12.902 0 01-2.489-.276c-.803-.16-4.596-1.054-5.321-1.226H9.75V31h5.295a57.603 57.603 0 012.146-1.018zm3.94 1.823a4.111 4.111 0 00-3.131.008c-.858.378-1.892.891-2.187 1.039l-.082.04-.211.108h-3.77v6.5l3.762.027c.022.006 1.154.274 2.385.56l.696.162c1 .232 1.942.447 2.281.514a7.665 7.665 0 003.796-.026c.667-.245 7.589-3.405 12.079-5.47a.867.867 0 00.45-.49.855.855 0 00-.03-.655.885.885 0 00-1.172-.419c-.343.152-8.03 3.558-8.663 3.827a2.82 2.82 0 01-1.378.167 2.842 2.842 0 01-1.022-.225l-4.715-2.008.783-1.84 4.668 1.987c.139.041.28.07.424.088a.881.881 0 00.773-.53.864.864 0 00-.464-1.13c-.003 0-4.567-1.942-5.271-2.234zm-.064-17.055v2.055a4.232 4.232 0 104.915 4.175H28a6.267 6.267 0 01-6.25 6.27 6.27 6.27 0 01-.683-12.5zm3.085-4.684c.827-.222 1.7.138 2.129.88l1.658 2.862h2.632v2.012H26.78l-2.018-3.483.001 4.92h6.38l3.607 6.083-1.73 1.026-3.022-5.097h-5.332a1.918 1.918 0 01-1.915-1.913v-5.463c0-.856.574-1.605 1.401-1.827zM24.75 4.5a2 2 0 110 4 2 2 0 010-4z"
});

function SvgHelpMobility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$i);
}

function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var _ref$h = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM17.192 29.985a6.091 6.091 0 014.704-.025c.707.292 5.287 2.24 5.287 2.24a2.869 2.869 0 011.747 2.445c2.543-1.124 6.186-2.738 6.24-2.761a2.883 2.883 0 013.807 1.388 2.859 2.859 0 01-1.39 3.811c-.53.244-2.958 1.36-5.519 2.527l-.67.305c-2.793 1.272-5.561 2.522-6.039 2.697a6.91 6.91 0 01-2.385.388 12.9 12.9 0 01-2.488-.276c-.803-.16-4.596-1.054-5.32-1.225H9.75V31.002h5.295a58.851 58.851 0 012.147-1.017zm3.94 1.822a4.119 4.119 0 00-3.131.006l-.467.211-.315.147c-.78.367-1.487.723-1.487.723l-.213.108H11.75v6.497l3.762.028c.022.005 1.154.273 2.385.56l.696.161c1 .232 1.942.447 2.28.514a7.667 7.667 0 003.797-.026c.427-.157 3.43-1.514 6.712-3.01l.582-.266.877-.4.584-.268c1.165-.533 2.306-1.056 3.323-1.524a.866.866 0 00.45-.49.854.854 0 00-.03-.655.886.886 0 00-1.172-.419c-.343.153-8.03 3.557-8.663 3.826a3.612 3.612 0 01-2.4-.058l-4.714-2.007.783-1.84 4.668 1.987c.138.04.28.07.424.088a.877.877 0 00.772-.528.86.86 0 00-.463-1.13c-.003-.003-4.567-1.943-5.271-2.235zM31.682 6.5l1.427 1.418-1.829 1.818.008.005-1.5 1.492-.008-.004-1.7 1.69.005.007-1.417 1.408-.005-.006-4.578 4.553.005.006-1.416 1.408-.005-.005-1.787 1.776.008.004-1.503 1.494-.007-.004L14.927 26 13.5 24.582l2.088-2.077a27.472 27.472 0 01-5.83-5.145l-.508-.628.508-.628c.267-.331 6.646-8.107 14.742-8.107 1.636.015 3.257.313 4.79.882L31.682 6.5zm1.426 4.267a27.44 27.44 0 016.135 5.337l.507.628-.507.628c-.267.33-6.646 8.107-14.743 8.107a14.305 14.305 0 01-5.151-1.017l1.588-1.58c1.15.383 2.352.586 3.563.6 5.884 0 10.993-4.957 12.638-6.739a25.986 25.986 0 00-5.488-4.514zm-3.832 3.81c.313.676.474 1.411.474 2.155a5.252 5.252 0 01-5.25 5.241 5.15 5.15 0 01-2.176-.482l1.589-1.58c.193.04.39.062.587.065a3.25 3.25 0 003.25-3.244 3.143 3.143 0 00-.063-.574zM24.5 9.995c-5.882 0-10.99 4.956-12.637 6.738a26.417 26.417 0 005.185 4.322l2.54-2.526a5.198 5.198 0 016.73-6.694l1.379-1.37a11.707 11.707 0 00-3.197-.47zm0 3.494a3.25 3.25 0 00-3.25 3.244c0 .044.012.086.013.13l3.378-3.36c-.047-.002-.092-.014-.14-.014z"
});

function SvgHelpVisualImpairment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$h);
}

function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var _ref$g = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM31.367 20.212a4.434 4.434 0 014.222 2.182v-1.885h2.931v8.652a1.244 1.244 0 001.316 1.387c.343.003.679-.091.969-.272l.695 2.206a4.392 4.392 0 01-2.433.768 2.95 2.95 0 01-3.105-2.453 4.961 4.961 0 01-4.62 2.453c-3.749 0-5.96-2.924-5.96-6.494 0-3.544 2.137-6.544 5.985-6.544zM17.286 15.75l6.854 17.352h-3.304l-1.513-3.967h-7.005L10.803 33.1H7.5l6.856-17.351h2.93zm14.603 7.115c-2.26 0-3.502 1.735-3.502 3.867 0 2.28 1.416 3.867 3.527 3.867a3.555 3.555 0 003.6-3.867 3.573 3.573 0 00-3.625-3.867zm-16.068-3.05l-2.434 6.446h4.867l-2.433-6.446z"
});

function SvgHighContrastLabeling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$g);
}

function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var _ref$f = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm0 2H3v43h43.001L46 3zM24.472 18a8.5 8.5 0 018.504 7.845l.022 9.655H40.5v2h-32v-2h7.502l.02-9.597A8.5 8.5 0 0124.472 18zm0 2a6.503 6.503 0 00-6.451 5.965l-.019 9.535h12.996l-.02-9.593A6.503 6.503 0 0024.472 20zM13.5 26v2h-5v-2h5zm27 0v2h-5v-2h5zM13.722 14.793l3.571 3.571-1.429 1.429-3.571-3.572 1.429-1.428zm21.54 0l1.43 1.428-3.572 3.572-1.429-1.428 3.572-3.572zM25.5 10.5v5h-2v-5h2z"
});

function SvgLightSignals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$f);
}

function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var _ref$e = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2h43zm0 2H3v43h43.001L46 3zM30.5 39.5v2h-21v-2h21zm11-14a2.002 2.002 0 012 2v12a2.002 2.002 0 01-2 2h-7a2.002 2.002 0 01-2-2v-12a2.002 2.002 0 012-2h7zm0 2h-7v12h7.001l-.001-12zM38 36a1 1 0 110 2 1 1 0 010-2zM13.134 8.5a6.857 6.857 0 014.366 1.583A6.857 6.857 0 0121.866 8.5H29.5v11h7.792c.93-.012 1.693.73 1.708 1.66v2.34h-2v-2h-7.5v3.91l-7.634-.001a4.402 4.402 0 00-3.53 1.639.95.95 0 01-.836.452.916.916 0 01-.837-.452A4.268 4.268 0 0013.5 25.43V35h17v2H13.208a1.687 1.687 0 01-1.708-1.66v-9.93h-6V8.5zm0 2H7.5v12.91h5.634a7.122 7.122 0 013.366.88V11.933a4.55 4.55 0 00-3.366-1.432zm14.366 0h-5.634a4.55 4.55 0 00-3.366 1.432v12.359a7.122 7.122 0 013.366-.88H27.5V10.5z"
});

function SvgMedialOffers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$e);
}

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var _ref$d = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zm-6 7.5v2h-5.948a.552.552 0 00-.552.552V19.5h-6.448a.552.552 0 00-.552.552v5.03l13.5 13.5L38.582 40l-13.5-13.5h-5.03a.552.552 0 00-.552.552V33.5h-6.448a.552.552 0 00-.552.552V40h-2v-5.948a2.554 2.554 0 012.552-2.552H17.5v-4.448a2.554 2.554 0 012.552-2.552h3.03L10.5 11.918l1.418-1.418L24.5 23.082v-3.03a2.554 2.554 0 012.552-2.552H31.5v-4.448a2.554 2.554 0 012.552-2.552H40z"
});

function SvgNoStairs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$d);
}

function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var _ref$c = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM14.5 26v2a6.5 6.5 0 106.5 6.5v-.212h2v.212a8.5 8.5 0 11-8.5-8.5zm3.62-5.423a2.184 2.184 0 012.457 1.02l2.368 4.114h3.947v2h-5.104l-2.944-5.115a.184.184 0 00-.344.091v6.491c.001.537.437.972.974.973h7.632l4.764 8.356-1.738.99-4.188-7.346h-6.47a2.977 2.977 0 01-2.974-2.973v-6.49c0-.99.665-1.855 1.62-2.11zM36.75 7.5A4.002 4.002 0 0141 11.711a4.352 4.352 0 01-4.525 4.525H33.93V21.5H31.5v-14zM19 12a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm17.626-4.276l-.17.009h-2.527v4.29h2.408a2.092 2.092 0 002.234-2.214 1.935 1.935 0 00-2.116-2.076z"
});

function SvgParkingWheelchairAccessible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$c);
}

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var _ref$b = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm0 2H3v43h43.001L46 3zm-8.855 3.5l4.897 4.489a1.412 1.412 0 010 2.082l-4.897 4.489h-9.273V42.5h-6.941V26.62h-9.273l-4.566-4.186a1.823 1.823 0 01.001-2.689l4.565-4.185h9.273V6.5h16.214zM25.872 26.62h-2.941V40.5h2.941V26.62zm0-9.06H12.436l-3.85 3.53 3.85 3.53h13.436v-7.06zM36.367 8.5H22.931v7.06h13.436l3.851-3.53-3.85-3.53z"
});

function SvgPictograms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$b);
}

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var _ref$a = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm0 2H3v43h43.002L46 3zM33.452 16.056a2.978 2.978 0 012.236.453 2.99 2.99 0 01.826 4.108l-3.412 5.574a3.002 3.002 0 01-3.985 1.072l-2.181-1.179-1.023 2.728c-.133.386-.053.814.21 1.125l5.047 5.986a4 4 0 01-3.06 6.577H15.726a3.725 3.725 0 010-7.45h3.6l-2.639-2.97a4.994 4.994 0 01-.959-5.032l2.385-6.548a5.314 5.314 0 017.704-2.75l3.83 2.273c.036.02.081.01.104-.023l1.802-2.682a2.978 2.978 0 011.9-1.262zm.512 1.947l-.127.016a.977.977 0 00-.624.414l-1.802 2.681a2.076 2.076 0 01-2.786.628l-3.83-2.273a3.314 3.314 0 00-4.804 1.715l-2.385 6.548a2.994 2.994 0 00.576 3.019l5.595 6.3h-8.052a1.725 1.725 0 100 3.45h12.386a2 2 0 001.53-3.29l-5.048-5.985a3.173 3.173 0 01-.558-3.102l1.834-4.89 4.199 2.27a1.002 1.002 0 001.33-.358l3.427-5.6a.992.992 0 00-.255-1.378.977.977 0 00-.733-.149zM25.5 5.945a4.5 4.5 0 110 9 4.5 4.5 0 010-9zm0 2a2.5 2.5 0 100 5 2.5 2.5 0 000-5z"
});

function SvgReligiousSpiritualReflection1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$a);
}

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var _ref$9 = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.002 2.002 0 012 2v43a2.002 2.002 0 01-2 2H3a2.002 2.002 0 01-2-2V3a2.002 2.002 0 012-2zm0 2H3v43h43.001L46 3zM28.808 30.5c.831.008 1.594.46 2 1.185A8.628 8.628 0 0038.33 36H40v2h-1.67a10.691 10.691 0 01-7.83-3.406V42h-2v-9.5h-8V42h-2v-7.406A10.692 10.692 0 0110.668 38H9v-2h1.668a8.628 8.628 0 007.523-4.314 2.313 2.313 0 012-1.186zM24.5 6.5c7.69 0 13.94 6.202 14 13.891a13.72 13.72 0 01-2.632 8.109l-1.621-1.167A11.746 11.746 0 0036.5 20.39c-.056-6.588-5.412-11.899-12-11.899s-11.944 5.311-12 11.899a11.77 11.77 0 002.047 6.65l-1.655 1.119a13.746 13.746 0 01-2.392-7.769c.06-7.69 6.31-13.89 14-13.89zm0 10A5.5 5.5 0 1119 22a5.507 5.507 0 015.5-5.5zm0 2a3.5 3.5 0 100 7 3.5 3.5 0 000-7z"
});

function SvgReligiousSpiritualReflection2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$9);
}

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var _ref$8 = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM27 8.5v32h3.5v2h-25v-2H8v-32h19zm-2 2H10v30h15v-30zm-4 13a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm13-3a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm6 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-6-6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm6 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm-6-6a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm6 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
});

function SvgRoomBraille(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$8);
}

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var _ref$7 = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM27 8.5v32h3.5v2h-25v-2H8v-32h19zm-2 2H10v30h15v-30zm-4 13a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM37.286 8.25a9.748 9.748 0 010 14l-1.398-1.409a7.778 7.778 0 000-11.182zm-3.388 2.465a6.317 6.317 0 010 9.07L32.5 18.38a4.351 4.351 0 000-6.257z"
});

function SvgRoomSignalingSystems(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$7);
}

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var _ref$6 = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM27 8.5v32h3.5v2h-25v-2H8v-32h19zm-2 2H10v30h15v-30zm-4 13a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM36.5 11c3.337 0 5.91 3.245 6.018 3.383L43 15l-.482.618C42.41 15.755 39.838 19 36.5 19c-3.337 0-5.91-3.245-6.018-3.382L30 15l.482-.617C30.59 14.245 33.163 11 36.5 11zm1.841 2.485a1.927 1.927 0 11-3.683.005 8.39 8.39 0 00-2.041 1.512A6.093 6.093 0 0036.5 17a6.131 6.131 0 003.883-2.002 8.259 8.259 0 00-2.042-1.513z"
});

function SvgRoomVisualDisplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$6);
}

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$5 = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 7.422h-8.5v2.09a6.004 6.004 0 015 5.91v1h-12v-1a6.004 6.004 0 015-5.91v-4.09H46V3zM14.5 26v2a6.5 6.5 0 106.5 6.5v-.212h2v.212a8.5 8.5 0 11-8.5-8.5zm3.62-5.423a2.184 2.184 0 012.457 1.02l2.368 4.114h3.947v2h-5.104l-2.944-5.115a.184.184 0 00-.344.091v6.491c.001.537.437.972.974.973h7.632l4.764 8.356-1.738.99-4.188-7.346h-6.47a2.977 2.977 0 01-2.974-2.973v-6.49c0-.99.665-1.855 1.62-2.11zm19.38 2.845v3h-2v-3h2zm-5 0v3h-2v-3h2zm10 0v3h-2v-3h2zm-5-5v3h-2v-3h2zm-5 0v3h-2v-3h2zm10 0v3h-2v-3h2zM19 12a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm17.5-2.578a4.006 4.006 0 00-3.873 3h7.746a4.006 4.006 0 00-3.873-3z"
});

function SvgSanitaryFacilitiesWheelchairAccessible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$5);
}

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$4 = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM30.01 17.425l.13.003c.523.04.97.39 1.132.888.122.341.099.717-.064 1.04l-3.636 7.122a.573.573 0 00.967.608l5.324-6.908a1.166 1.166 0 011.878 1.378l-5.023 7.163a.706.706 0 001.093.89l4.74-4.989a1.188 1.188 0 111.768 1.588l-5.267 6.187a.478.478 0 00.676.67L38.3 29.09a1.15 1.15 0 01.876-.279 1.165 1.165 0 01.687 2.014 600.183 600.183 0 00-7.7 7.226 25.635 25.635 0 01-3.938 3.138 6.9 6.9 0 01-6.427.485c-2.009-.868-5.08-2.668-5.08-6.55l-.336-10.82a1.81 1.81 0 013.615-.068l.12 5.12a1.18 1.18 0 00.856 1.186 1.382 1.382 0 001.555-.8c.145-.247 1.481-2.684 2.891-5.26l.327-.597c1.578-2.885 3.142-5.749 3.142-5.749.236-.467.73-.747 1.253-.707zM8.728 20.89a1.808 1.808 0 012.51-.126l3.127 2.722c.14.122.221.299.223.485l.08 4.056a.263.263 0 01-.446.209l-5.376-4.763a1.808 1.808 0 01-.118-2.583zM20.23 7.15a1.168 1.168 0 012.045.767l-.013 8.742a.714.714 0 001.097.584.708.708 0 00.32-.49l1.03-6.737a1.236 1.236 0 011.233-1.068l.075.006a1.187 1.187 0 011.063 1.3 75.8 75.8 0 01-.8 8.088l-.005.011-.123.246c-.626 1.248-3.34 6.628-3.73 6.888a.43.43 0 01-.734-.265l-.033-1.472a3.222 3.222 0 00-2.73-3.38 4.379 4.379 0 00-2.543.45l-.015.002a.43.43 0 01-.487-.366l-.016-.16-1.185-11.2c-.053-.393.064-.79.322-1.09a1.294 1.294 0 012.26.683l1.123 7.911a.582.582 0 00.698.505.599.599 0 00.449-.567l.41-8.63c.008-.278.11-.545.29-.758z"
});

function SvgSignLanguageInterpreter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$4);
}

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$3 = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zm-11.419 8.5L36 12.919l-3.448 3.447.009.004-1.526 1.526-.008-.004-2.329 2.329.006.006-1.416 1.416-.005-.007-5.647 5.647.007.005-1.416 1.416-.006-.006-2.365 2.365.009.003-1.522 1.522-.008-.004L11.919 37 10.5 35.581l3.944-3.944a33.018 33.018 0 01-8.124-6.48l-.57-.657.57-.656c.059-.068.357-.408.864-.921l.25-.25C9.978 20.158 16.583 14.5 24.5 14.5c2.05.02 4.084.379 6.018 1.063L34.58 11.5zm-.134 5.822a33.222 33.222 0 018.233 6.522l.57.656-.57.656-.044.05a21.96 21.96 0 01-.82.871l-.25.25C39.022 28.842 32.417 34.5 24.5 34.5a18.546 18.546 0 01-6.133-1.098l1.602-1.602c1.469.45 2.995.685 4.531.7 7.557 0 14.074-5.98 16.059-8a32.138 32.138 0 00-7.599-5.692zm-4.559 4.559c.402.815.61 1.71.612 2.619a6.007 6.007 0 01-6 6 5.94 5.94 0 01-2.62-.612l1.553-1.552c.346.104.705.159 1.067.164a4.004 4.004 0 004-4 3.918 3.918 0 00-.164-1.067zM24.5 16.5c-7.557 0-14.074 5.98-16.059 8a32.187 32.187 0 007.497 5.643l3.124-3.124a5.987 5.987 0 017.957-7.957l1.903-1.903A15.987 15.987 0 0024.5 16.5zm0 4a4.004 4.004 0 00-4 4c.004.322.046.642.128.954l4.826-4.826a3.96 3.96 0 00-.954-.128z"
});

function SvgVisualImpairment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3);
}

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM17.535 36.615v2.013H12.87v2.858h11.762v-2.858h-4.666v-2.013h11.341v2.013H26.64v2.858h4.666V43.5H6.194v-2.014h4.666v-2.858H6.194v-2.013h11.341zM13.292 22a4.25 4.25 0 014.438 4.447v8.122H6v-8.122A4.25 4.25 0 0110.437 22zm13.771 0a4.25 4.25 0 014.437 4.447v8.122H19.771v-8.122A4.25 4.25 0 0124.208 22zM13.471 24.01l-.179.005h-2.855a2.277 2.277 0 00-2.428 2.433v6.108h7.712v-6.108a2.278 2.278 0 00-2.429-2.433zm13.771 0l-.179.005h-2.855a2.278 2.278 0 00-2.428 2.433v6.108h7.711v-6.108a2.277 2.277 0 00-2.428-2.433zM18.501 5.5a7 7 0 01-.001 14 7.008 7.008 0 01-7-7 7 7 0 017-7zM18.5 7.487a5.014 5.014 0 100 10.027 5.014 5.014 0 000-10.027zM35.75 9c3.337 0 5.91 3.245 6.018 3.383l.482.617-.482.618C41.66 13.755 39.088 17 35.75 17c-3.337 0-5.91-3.245-6.018-3.382L29.25 13l.482-.617C29.84 12.245 32.413 9 35.75 9zM19.457 9v3.434l1.378.96L19.717 15 17.5 13.457V9h1.957zm18.134 2.485a1.927 1.927 0 11-3.683.005 8.39 8.39 0 00-2.041 1.512A6.093 6.093 0 0035.75 15a6.131 6.131 0 003.883-2.002 8.259 8.259 0 00-2.042-1.513z"
});

function SvgWaitingAreaVisualDisplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2);
}

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM16.498 19.513A9.5 9.5 0 0126.446 28H29.5v-4.5h2V28h6.836l-3.793-3.793 1.414-1.414 5.5 5.5a1 1 0 010 1.414l-5.5 5.5-1.414-1.414L38.336 30H31.5v4.5h-2V30h-3.054a9.5 9.5 0 11-9.948-10.487zM17 21.5a7.5 7.5 0 000 15 7.508 7.508 0 007.5-7.5 7.5 7.5 0 00-7.5-7.5zM39.474 6c1.3-.052 2.53.594 3.224 1.696l.076.12-1.483 1.06-.083-.142a2.072 2.072 0 00-3.838 1.154 2.019 2.019 0 002.063 2.155 1.934 1.934 0 001.872-1.346l.055-.144 1.64.678-.058.139a3.733 3.733 0 01-3.627 2.43 3.637 3.637 0 01-3.815-3.788A3.868 3.868 0 0139.474 6zm-13.49.17l1.329 4.428 1.323-4.428h1.73l1.321 4.428 1.33-4.428H35l-2.447 7.5H30.84l-1.335-4.147-1.343 4.147h-1.713l-.035-.104L24 6.17h1.983z"
});

function SvgWcGenderfree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1);
}

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M46 1a2.003 2.003 0 012 2v43a2.003 2.003 0 01-2 2H3a2.003 2.003 0 01-2-2V3a2.003 2.003 0 012-2zm0 2H3v43h43.002L46 3zM14.5 26v2a6.5 6.5 0 106.5 6.5v-.212h2v.212a8.5 8.5 0 11-8.5-8.5zm3.62-5.422a2.184 2.184 0 012.457 1.02l2.368 4.113h3.947v2h-5.104l-2.944-5.115a.184.184 0 00-.344.092v6.49c.001.538.437.973.974.973h7.632l4.764 8.356-1.738.99-4.188-7.346h-6.47a2.977 2.977 0 01-2.974-2.973v-6.49c0-.99.665-1.855 1.62-2.11zM19 12a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm20.474-8c1.3-.052 2.53.595 3.224 1.696l.076.12-1.483 1.061-.083-.143a2.072 2.072 0 00-3.839 1.155 2.019 2.019 0 002.063 2.155 1.934 1.934 0 001.873-1.347l.055-.143 1.64.677-.058.139a3.733 3.733 0 01-3.627 2.43 3.637 3.637 0 01-3.815-3.787A3.868 3.868 0 0139.474 6zm-13.491.17l1.33 4.428 1.323-4.428h1.729l1.322 4.428 1.33-4.428H35l-2.448 7.5h-1.713l-1.335-4.147-1.343 4.147h-1.713l-.035-.104L24 6.17h1.983z"
});

function SvgWcWheelchairAccessible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
}

var AccessibleWebsite = function AccessibleWebsite(props) {
  return /*#__PURE__*/React__default.createElement(SvgAccessibleWebsite, _extends$C({
    "data-icon": "accessible-website"
  }, props));
};
var AcousticSignals = function AcousticSignals(props) {
  return /*#__PURE__*/React__default.createElement(SvgAcousticSignals, _extends$C({
    "data-icon": "acoustic-signals"
  }, props));
};
var AssistanceDog = function AssistanceDog(props) {
  return /*#__PURE__*/React__default.createElement(SvgAssistanceDog, _extends$C({
    "data-icon": "assistance-dog"
  }, props));
};
var AutomaticEntranceDoor = function AutomaticEntranceDoor(props) {
  return /*#__PURE__*/React__default.createElement(SvgAutomaticEntranceDoor, _extends$C({
    "data-icon": "automatic-entrance-door"
  }, props));
};
var BarrierFreeAccessibility = function BarrierFreeAccessibility(props) {
  return /*#__PURE__*/React__default.createElement(SvgBarrierFreeAccessibility, _extends$C({
    "data-icon": "barrier-free-accessibility"
  }, props));
};
var Braille = function Braille(props) {
  return /*#__PURE__*/React__default.createElement(SvgBraille, _extends$C({
    "data-icon": "braille"
  }, props));
};
var BuildingPlanBraille = function BuildingPlanBraille(props) {
  return /*#__PURE__*/React__default.createElement(SvgBuildingPlanBraille, _extends$C({
    "data-icon": "building-plan-braille"
  }, props));
};
var CommunicationAids = function CommunicationAids(props) {
  return /*#__PURE__*/React__default.createElement(SvgCommunicationAids, _extends$C({
    "data-icon": "communication-aids"
  }, props));
};
var Dementia = function Dementia(props) {
  return /*#__PURE__*/React__default.createElement(SvgDementia, _extends$C({
    "data-icon": "dementia"
  }, props));
};
var EasyLanguage = function EasyLanguage(props) {
  return /*#__PURE__*/React__default.createElement(SvgEasyLanguage, _extends$C({
    "data-icon": "easy-language"
  }, props));
};
var ElevatorBraille = function ElevatorBraille(props) {
  return /*#__PURE__*/React__default.createElement(SvgElevatorBraille, _extends$C({
    "data-icon": "elevator-braille"
  }, props));
};
var ElevatorSeat = function ElevatorSeat(props) {
  return /*#__PURE__*/React__default.createElement(SvgElevatorSeat, _extends$C({
    "data-icon": "elevator-seat"
  }, props));
};
var ElevatorVisualDisplay = function ElevatorVisualDisplay(props) {
  return /*#__PURE__*/React__default.createElement(SvgElevatorVisualDisplay, _extends$C({
    "data-icon": "elevator-visual-display"
  }, props));
};
var ElevatorVoiceAnnouncement = function ElevatorVoiceAnnouncement(props) {
  return /*#__PURE__*/React__default.createElement(SvgElevatorVoiceAnnouncement, _extends$C({
    "data-icon": "elevator-voice-announcement"
  }, props));
};
var ElevatorWheelchairAccessible = function ElevatorWheelchairAccessible(props) {
  return /*#__PURE__*/React__default.createElement(SvgElevatorWheelchairAccessible, _extends$C({
    "data-icon": "elevator-wheelchair-accessible"
  }, props));
};
var EmergencyCallSystemsWheelchairAccessible = function EmergencyCallSystemsWheelchairAccessible(props) {
  return /*#__PURE__*/React__default.createElement(SvgEmergencyCallSystemsWheelchairAccessible, _extends$C({
    "data-icon": "emergency-call-systems-wheelchair-accessible"
  }, props));
};
var GuideSystemForTheBlind = function GuideSystemForTheBlind(props) {
  return /*#__PURE__*/React__default.createElement(SvgGuideSystemForTheBlind, _extends$C({
    "data-icon": "guide-system-for-the-blind"
  }, props));
};
var HearingImpairment = function HearingImpairment(props) {
  return /*#__PURE__*/React__default.createElement(SvgHearingImpairment, _extends$C({
    "data-icon": "hearing-impairment"
  }, props));
};
var HelpDementia = function HelpDementia(props) {
  return /*#__PURE__*/React__default.createElement(SvgHelpDementia, _extends$C({
    "data-icon": "help-dementia"
  }, props));
};
var HelpMobility = function HelpMobility(props) {
  return /*#__PURE__*/React__default.createElement(SvgHelpMobility, _extends$C({
    "data-icon": "help-mobility"
  }, props));
};
var HelpVisualImpairment = function HelpVisualImpairment(props) {
  return /*#__PURE__*/React__default.createElement(SvgHelpVisualImpairment, _extends$C({
    "data-icon": "help-visual-impairment"
  }, props));
};
var HighContrastLabeling = function HighContrastLabeling(props) {
  return /*#__PURE__*/React__default.createElement(SvgHighContrastLabeling, _extends$C({
    "data-icon": "high-contrast-labeling"
  }, props));
};
var LightSignals = function LightSignals(props) {
  return /*#__PURE__*/React__default.createElement(SvgLightSignals, _extends$C({
    "data-icon": "light-signals"
  }, props));
};
var MedialOffers = function MedialOffers(props) {
  return /*#__PURE__*/React__default.createElement(SvgMedialOffers, _extends$C({
    "data-icon": "medial-offers"
  }, props));
};
var NoStairs = function NoStairs(props) {
  return /*#__PURE__*/React__default.createElement(SvgNoStairs, _extends$C({
    "data-icon": "no-stairs"
  }, props));
};
var ParkingWheelchairAccessible = function ParkingWheelchairAccessible(props) {
  return /*#__PURE__*/React__default.createElement(SvgParkingWheelchairAccessible, _extends$C({
    "data-icon": "parking-wheelchair-accessible"
  }, props));
};
var Pictograms = function Pictograms(props) {
  return /*#__PURE__*/React__default.createElement(SvgPictograms, _extends$C({
    "data-icon": "pictograms"
  }, props));
};
var ReligiousSpiritualReflection1 = function ReligiousSpiritualReflection1(props) {
  return /*#__PURE__*/React__default.createElement(SvgReligiousSpiritualReflection1, _extends$C({
    "data-icon": "religious-spiritual-reflection-1"
  }, props));
};
var ReligiousSpiritualReflection2 = function ReligiousSpiritualReflection2(props) {
  return /*#__PURE__*/React__default.createElement(SvgReligiousSpiritualReflection2, _extends$C({
    "data-icon": "religious-spiritual-reflection-2"
  }, props));
};
var RoomBraille = function RoomBraille(props) {
  return /*#__PURE__*/React__default.createElement(SvgRoomBraille, _extends$C({
    "data-icon": "room-braille"
  }, props));
};
var RoomSignalingSystems = function RoomSignalingSystems(props) {
  return /*#__PURE__*/React__default.createElement(SvgRoomSignalingSystems, _extends$C({
    "data-icon": "room-signaling-systems"
  }, props));
};
var RoomVisualDisplay = function RoomVisualDisplay(props) {
  return /*#__PURE__*/React__default.createElement(SvgRoomVisualDisplay, _extends$C({
    "data-icon": "room-visual-display"
  }, props));
};
var SanitaryFacilitiesWheelchairAccessible = function SanitaryFacilitiesWheelchairAccessible(props) {
  return /*#__PURE__*/React__default.createElement(SvgSanitaryFacilitiesWheelchairAccessible, _extends$C({
    "data-icon": "sanitary-facilities-wheelchair-accessible"
  }, props));
};
var SignLanguageInterpreter = function SignLanguageInterpreter(props) {
  return /*#__PURE__*/React__default.createElement(SvgSignLanguageInterpreter, _extends$C({
    "data-icon": "sign-language-interpreter"
  }, props));
};
var VisualImpairment = function VisualImpairment(props) {
  return /*#__PURE__*/React__default.createElement(SvgVisualImpairment, _extends$C({
    "data-icon": "visual-impairment"
  }, props));
};
var WaitingAreaVisualDisplay = function WaitingAreaVisualDisplay(props) {
  return /*#__PURE__*/React__default.createElement(SvgWaitingAreaVisualDisplay, _extends$C({
    "data-icon": "waiting-area-visual-display"
  }, props));
};
var WCGenderfree = function WCGenderfree(props) {
  return /*#__PURE__*/React__default.createElement(SvgWcGenderfree, _extends$C({
    "data-icon": "wc-genderfree"
  }, props));
};
var WCWheelchairAccessible = function WCWheelchairAccessible(props) {
  return /*#__PURE__*/React__default.createElement(SvgWcWheelchairAccessible, _extends$C({
    "data-icon": "wc-wheelchair-accessible"
  }, props));
};

var _excluded = ["name", "className"];

var Icon = function Icon(_ref) {
  var name = _ref.name,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  switch (name) {
    case 'accessible-website':
      return /*#__PURE__*/React__default.createElement(AccessibleWebsite, _extends$C({
        className: className
      }, rest));

    case 'acoustic-signals':
      return /*#__PURE__*/React__default.createElement(AcousticSignals, _extends$C({
        className: className
      }, rest));

    case 'assistance-dog':
      return /*#__PURE__*/React__default.createElement(AssistanceDog, _extends$C({
        className: className
      }, rest));

    case 'automatic-entrance-door':
      return /*#__PURE__*/React__default.createElement(AutomaticEntranceDoor, _extends$C({
        className: className
      }, rest));

    case 'barrier-free-accessibility':
      return /*#__PURE__*/React__default.createElement(BarrierFreeAccessibility, _extends$C({
        className: className
      }, rest));

    case 'braille':
      return /*#__PURE__*/React__default.createElement(Braille, _extends$C({
        className: className
      }, rest));

    case 'building-plan-braille':
      return /*#__PURE__*/React__default.createElement(BuildingPlanBraille, _extends$C({
        className: className
      }, rest));

    case 'communication-aids':
      return /*#__PURE__*/React__default.createElement(CommunicationAids, _extends$C({
        className: className
      }, rest));

    case 'dementia':
      return /*#__PURE__*/React__default.createElement(Dementia, _extends$C({
        className: className
      }, rest));

    case 'easy-language':
      return /*#__PURE__*/React__default.createElement(EasyLanguage, _extends$C({
        className: className
      }, rest));

    case 'elevator-braille':
      return /*#__PURE__*/React__default.createElement(ElevatorBraille, _extends$C({
        className: className
      }, rest));

    case 'elevator-seat':
      return /*#__PURE__*/React__default.createElement(ElevatorSeat, _extends$C({
        className: className
      }, rest));

    case 'elevator-visual-display':
      return /*#__PURE__*/React__default.createElement(ElevatorVisualDisplay, _extends$C({
        className: className
      }, rest));

    case 'elevator-voice-announcement':
      return /*#__PURE__*/React__default.createElement(ElevatorVoiceAnnouncement, _extends$C({
        className: className
      }, rest));

    case 'elevator-wheelchair-accessible':
      return /*#__PURE__*/React__default.createElement(ElevatorWheelchairAccessible, _extends$C({
        className: className
      }, rest));

    case 'emergency-call-systems-wheelchair-accessible':
      return /*#__PURE__*/React__default.createElement(EmergencyCallSystemsWheelchairAccessible, _extends$C({
        className: className
      }, rest));

    case 'guide-system-for-the-blind':
      return /*#__PURE__*/React__default.createElement(GuideSystemForTheBlind, _extends$C({
        className: className
      }, rest));

    case 'hearing-impairment':
      return /*#__PURE__*/React__default.createElement(HearingImpairment, _extends$C({
        className: className
      }, rest));

    case 'help-dementia':
      return /*#__PURE__*/React__default.createElement(HelpDementia, _extends$C({
        className: className
      }, rest));

    case 'help-mobility':
      return /*#__PURE__*/React__default.createElement(HelpMobility, _extends$C({
        className: className
      }, rest));

    case 'help-visual-impairment':
      return /*#__PURE__*/React__default.createElement(HelpVisualImpairment, _extends$C({
        className: className
      }, rest));

    case 'high-contrast-labeling':
      return /*#__PURE__*/React__default.createElement(HighContrastLabeling, _extends$C({
        className: className
      }, rest));

    case 'light-signals':
      return /*#__PURE__*/React__default.createElement(LightSignals, _extends$C({
        className: className
      }, rest));

    case 'medial-offers':
      return /*#__PURE__*/React__default.createElement(MedialOffers, _extends$C({
        className: className
      }, rest));

    case 'no-stairs':
      return /*#__PURE__*/React__default.createElement(NoStairs, _extends$C({
        className: className
      }, rest));

    case 'parking-wheelchair-accessible':
      return /*#__PURE__*/React__default.createElement(ParkingWheelchairAccessible, _extends$C({
        className: className
      }, rest));

    case 'pictograms':
      return /*#__PURE__*/React__default.createElement(Pictograms, _extends$C({
        className: className
      }, rest));

    case 'religious-spiritual-reflection-1':
      return /*#__PURE__*/React__default.createElement(ReligiousSpiritualReflection1, _extends$C({
        className: className
      }, rest));

    case 'religious-spiritual-reflection-2':
      return /*#__PURE__*/React__default.createElement(ReligiousSpiritualReflection2, _extends$C({
        className: className
      }, rest));

    case 'room-braille':
      return /*#__PURE__*/React__default.createElement(RoomBraille, _extends$C({
        className: className
      }, rest));

    case 'room-signaling-systems':
      return /*#__PURE__*/React__default.createElement(RoomSignalingSystems, _extends$C({
        className: className
      }, rest));

    case 'room-visual-display':
      return /*#__PURE__*/React__default.createElement(RoomVisualDisplay, _extends$C({
        className: className
      }, rest));

    case 'sanitary-facilities-wheelchair-accessible':
      return /*#__PURE__*/React__default.createElement(SanitaryFacilitiesWheelchairAccessible, _extends$C({
        className: className
      }, rest));

    case 'sign-language-interpreter':
      return /*#__PURE__*/React__default.createElement(SignLanguageInterpreter, _extends$C({
        className: className
      }, rest));

    case 'visual-impairment':
      return /*#__PURE__*/React__default.createElement(VisualImpairment, _extends$C({
        className: className
      }, rest));

    case 'waiting-area-visual-display':
      return /*#__PURE__*/React__default.createElement(WaitingAreaVisualDisplay, _extends$C({
        className: className
      }, rest));

    case 'wc-genderfree':
      return /*#__PURE__*/React__default.createElement(WCGenderfree, _extends$C({
        className: className
      }, rest));

    case 'wc-wheelchair-accessible':
      return /*#__PURE__*/React__default.createElement(WCWheelchairAccessible, _extends$C({
        className: className
      }, rest));

    default:
      return /*#__PURE__*/React__default.createElement(Braille, _extends$C({
        className: className
      }, rest));
  }
};

Icon.propTypes = {
  name: PropTypes.string,
  // icon filename
  className: PropTypes.string
};
Icon.defaultProps = {
  name: '',
  className: ''
};

export { AccessibleWebsite, AcousticSignals, AssistanceDog, AutomaticEntranceDoor, BarrierFreeAccessibility, Braille, BuildingPlanBraille, CommunicationAids, Dementia, EasyLanguage, ElevatorBraille, ElevatorSeat, ElevatorVisualDisplay, ElevatorVoiceAnnouncement, ElevatorWheelchairAccessible, EmergencyCallSystemsWheelchairAccessible, GuideSystemForTheBlind, HearingImpairment, HelpDementia, HelpMobility, HelpVisualImpairment, HighContrastLabeling, LightSignals, MedialOffers, NoStairs, ParkingWheelchairAccessible, Pictograms, ReligiousSpiritualReflection1, ReligiousSpiritualReflection2, RoomBraille, RoomSignalingSystems, RoomVisualDisplay, SanitaryFacilitiesWheelchairAccessible, SignLanguageInterpreter, VisualImpairment, WCGenderfree, WCWheelchairAccessible, WaitingAreaVisualDisplay, Icon as default };
